import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'stampa_preventivo';

const stampa_pdf = (settings, params, callback) => generateRequest('/preventivi/stampa_preventivo', settings, {action: "print" , data: params}, callback);

const apiEndpoint = {
  stampa_pdf,
}

export default apiEndpoint;